import { getPostHogClient } from "@/lib/posthog/client";

type PostHogClientLike = {
  get_distinct_id?: () => string;
  get_session_id?: () => string | number | null;
  get_session_replay_url?: (options?: Record<string, unknown>) => string;
};

type PostHogRequestContext = {
  posthog?: {
    distinctId?: string;
    sessionId?: string;
    replayUrl?: string;
  };
};

export function buildPostHogRequestContext(): PostHogRequestContext {
  const client = getPostHogClient() as PostHogClientLike | null;
  if (!client) return {};

  const distinctId = client.get_distinct_id?.();
  const sessionIdRaw = client.get_session_id?.();
  const sessionId =
    sessionIdRaw === null || sessionIdRaw === undefined
      ? undefined
      : String(sessionIdRaw);
  const replayUrl = client.get_session_replay_url?.({
    withTimestamp: true,
    timestampLookBack: 20,
  });

  const posthog = {
    ...(distinctId ? { distinctId } : {}),
    ...(sessionId ? { sessionId } : {}),
    ...(replayUrl ? { replayUrl } : {}),
  };

  return Object.keys(posthog).length > 0 ? { posthog } : {};
}
